import { FlexBox } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';
import { IllustrationMessage } from '../../common';

interface ILoadingScreenProps {
}

const LoadingIllustrationBlock = styled(FlexBox)`
    height: 100%;
    min-height:450px;
`;

export function LoadingIllustration(props: ILoadingScreenProps) {
    return (
        <LoadingIllustrationBlock alignItems="center">
            <IllustrationMessage type="ap-loading" />
        </LoadingIllustrationBlock>

    );
}
